var _defs, _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcWapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#32ba46;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_wapp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 42,
    height: 42,
    rx: 7.18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25,41.12A16,16,0,0,1,17,39l-6.27,2.15L12,34.49A15.89,15.89,0,0,1,8.92,25,16.08,16.08,0,1,1,25,41.12Zm-7.73-4.78.48.3a13.72,13.72,0,1,0-3.53-3.18l.33.43-.7,3.62Z",
    transform: "translate(-4 -4.04)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.88,18.86s.94-1.65,1.71-1.74,1.76-.1,2,.41S22.08,21,22.08,21a1.17,1.17,0,0,1-.11,1,9.45,9.45,0,0,1-1,1.2.87.87,0,0,0,0,1A18.37,18.37,0,0,0,23.21,27a12.38,12.38,0,0,0,3.68,2.16.74.74,0,0,0,.56-.18c.22-.22,1.42-1.71,1.42-1.71a.84.84,0,0,1,1-.2c.63.29,3.39,1.66,3.39,1.66a.6.6,0,0,1,.32.61,3.83,3.83,0,0,1-.6,2.08A4.8,4.8,0,0,1,29.65,33a14.82,14.82,0,0,1-8.23-3.68c-2.25-2.25-4.24-4.53-4.71-6.6S16.3,19.72,16.88,18.86Z",
    transform: "translate(-4 -4.04)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWapp);
export default __webpack_public_path__ + "static/media/ic_wapp.b0f22dabf36a09c6f20f625cdac9b774.svg";
export { ForwardRef as ReactComponent };